(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        window.initTypeaheadAjax = function() {

            $('[data-plugin=typeheadajax]:not(".initiated")').each(function () {

                $(this).addClass("initiated");
                var url = $(this).attr('data-url');

                var searchData = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: url + '?q=%QUERY',
                        wildcard: '%QUERY'
                    }
                });


                $(this).typeahead(null, {
                    name: 'search',
                    limit: 15,
                    display: 'value',
                    source: searchData,
                    templates: {
                        suggestion: function (data) {
                            var ret = '<div>';
                            if (data.html != undefined) {
                                ret += data.html;
                            } else {
                                ret += data.value;
                            }
                            ret += '</div>';
                            return ret;
                        }
                    }
                });

                var listen = $(this).attr('data-listen');

                if (listen != undefined) {
                    var $that = $(this);
                    $(document).on(listen, function (event, item) {
                       if(item.inset != undefined){
                           var target = $that.data('inset');
                           if (target != undefined) {
                               $(target).append(item.inset);
                           }else{
                               $that.parent().parent().find('.inset').first().append(item.inset);

                           }
                       }
                    });
                }


                $(this).bind('typeahead:select', function (ev, suggestion) {
                    if (suggestion.slidepanel != undefined){
                        window.showSlidePanel(suggestion.slidepanel);
                    }
                    if (suggestion.inset!=undefined){
                        var target = $(this).data('inset');
                        if (target != undefined) {
                            $(target).append(suggestion.inset);
                        }else{
                            $(this).parent().parent().find('.inset').first().append(suggestion.inset);

                        }

                    }
                    $(this).typeahead('open');
                    $(this).typeahead('val', '');
                    $(this).blur();

                });

            })
        }

        initTypeaheadAjax();

    });

})(document, window, jQuery);
